import { KeyboardArrowLeft as KeyboardArrowLeftIcon } from '@mui/icons-material';

const KeyboardArrowLeft = (): JSX.Element => <KeyboardArrowLeftIcon fontSize="inherit" />;

export default KeyboardArrowLeft;
